// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeProcessSteps_home-process-steps__\\+2W4U {
  padding: 100px 0 100px;
  background: #f3f7ff;
}
.HomeProcessSteps_home-process-steps__container__uDMlJ {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
}
.HomeProcessSteps_home-process-steps__item__sQl0g {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  padding: 0 15px;
}
.HomeProcessSteps_home-process-steps__icon-wrapper__DFDcr {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
}
.HomeProcessSteps_home-process-steps__icon__XWOCa {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid var(--accent-color);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}
.HomeProcessSteps_home-process-steps__icon__XWOCa svg {
  font-size: 32px;
  color: var(--accent-color);
}
.HomeProcessSteps_home-process-steps__icon__XWOCa:hover {
  background: var(--accent-color);
  transform: scale(1.05);
}
.HomeProcessSteps_home-process-steps__icon__XWOCa:hover svg {
  color: #fff;
}
.HomeProcessSteps_home-process-steps__connector__13SFC {
  position: absolute;
  top: 50%;
  left: calc(50% + 40px);
  width: calc(100% - 45px);
  height: 0;
  border-top: 2px dashed rgba(0, 0, 0, 0.2);
  transform: translateY(-50%);
  z-index: 1;
}
.HomeProcessSteps_home-process-steps__title__hQEzt {
  font-size: 20px;
  font-weight: 700;
  color: var(--accent-color);
  margin: 0 0 8px;
}
.HomeProcessSteps_home-process-steps__description__2EQ1j {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0;
  max-width: 180px;
}
.HomeProcessSteps_home-process-steps__features__\\+V-ZA {
  padding: 60px 0 100px;
}
.HomeProcessSteps_home-process-steps__features-title__gXNii {
  font-size: 32px;
  font-weight: 700;
  color: var(--accent-color);
  text-align: center;
  margin: 40px 0 40px !important;
}
.HomeProcessSteps_home-process-steps__features-grid__c5Rw8 {
  display: flex;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
}
.HomeProcessSteps_home-process-steps__feature-card__QWazK {
  flex: 1 1;
  height: 200px;
  border-radius: 12px;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.HomeProcessSteps_home-process-steps__feature-card__QWazK:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}
.HomeProcessSteps_home-process-steps__feature-card__QWazK:hover .HomeProcessSteps_home-process-steps__feature-overlay__9Ufzr {
  background: rgba(10, 36, 77, 0.85);
}
.HomeProcessSteps_home-process-steps__feature-card__QWazK:hover .HomeProcessSteps_home-process-steps__feature-description__lYycU {
  opacity: 1;
  max-height: 100px;
  margin-top: 10px;
}
.HomeProcessSteps_home-process-steps__feature-overlay__9Ufzr {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(10, 36, 77, 0.7) 0%, rgba(10, 36, 77, 0) 60%);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 20px;
  transition: background 0.3s ease;
}
.HomeProcessSteps_home-process-steps__feature-title__YPUNs {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}
.HomeProcessSteps_home-process-steps__feature-description__lYycU {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  margin: 0;
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition: opacity 0.3s ease, max-height 0.3s ease, margin 0.3s ease;
}
@media only screen and (max-width: 768px) {
  .HomeProcessSteps_home-process-steps__\\+2W4U {
    padding: 60px 0 40px;
  }
  .HomeProcessSteps_home-process-steps__container__uDMlJ {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
  .HomeProcessSteps_home-process-steps__item__sQl0g {
    width: 100%;
    max-width: 300px;
  }
  .HomeProcessSteps_home-process-steps__connector__13SFC {
    display: none;
  }
  .HomeProcessSteps_home-process-steps__description__2EQ1j {
    max-width: 100%;
  }
  .HomeProcessSteps_home-process-steps__features-title__gXNii {
    font-size: 24px;
  }
  .HomeProcessSteps_home-process-steps__features-grid__c5Rw8 {
    flex-wrap: wrap;
  }
  .HomeProcessSteps_home-process-steps__feature-card__QWazK {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 8px);
    height: 160px;
  }
}
@media only screen and (max-width: 480px) {
  .HomeProcessSteps_home-process-steps__feature-card__QWazK {
    flex: 0 0 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeProcessSteps/HomeProcessSteps.module.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,mBAAA;AACJ;AACI;EACI,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AACR;AAEI;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAAR;AAGI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AADR;AAII;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AAFR;AAIQ;EACI,eAAA;EACA,0BAAA;AAFZ;AAKQ;EACI,+BAAA;EACA,sBAAA;AAHZ;AAKY;EACI,WAAA;AAHhB;AAQI;EACI,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,wBAAA;EACA,SAAA;EACA,yCAAA;EACA,2BAAA;EACA,UAAA;AANR;AASI;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAPR;AAUI;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AARR;AAWI;EACI,qBAAA;AATR;AAYI;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,8BAAA;AAVR;AAaI;EACI,aAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAXR;AAcI;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,qDAAA;AAZR;AAcQ;EACI,2BAAA;EACA,0CAAA;AAZZ;AAcY;EACI,kCAAA;AAZhB;AAeY;EACI,UAAA;EACA,iBAAA;EACA,gBAAA;AAbhB;AAkBI;EACI,kBAAA;EACA,QAAA;EACA,sFAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,gCAAA;AAhBR;AAmBI;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAjBR;AAoBI;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,qEAAA;AAlBR;AAqBI;EAjKJ;IAkKQ,oBAAA;EAlBN;EAoBM;IACI,sBAAA;IACA,mBAAA;IACA,SAAA;EAlBV;EAqBM;IACI,WAAA;IACA,gBAAA;EAnBV;EAsBM;IACI,aAAA;EApBV;EAuBM;IACI,eAAA;EArBV;EAwBM;IACI,eAAA;EAtBV;EAyBM;IACI,eAAA;EAvBV;EA0BM;IACI,YAAA;IAAA,cAAA;IAAA,2BAAA;IACA,aAAA;EAxBV;AACF;AA2BI;EACI;IACI,cAAA;EAzBV;AACF","sourcesContent":[".home-process-steps {\n    padding: 100px 0 100px;\n    background: #f3f7ff;\n\n    &__container {\n        display: flex;\n        justify-content: center;\n        align-items: flex-start;\n        max-width: 1000px;\n        margin: 0 auto;\n        padding: 0 20px;\n        position: relative;\n    }\n\n    &__item {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        position: relative;\n        padding: 0 15px;\n    }\n\n    &__icon-wrapper {\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    &__icon {\n        width: 70px;\n        height: 70px;\n        border-radius: 50%;\n        border: 2px solid var(--accent-color);\n        background: #fff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        z-index: 2;\n        transition: all 0.3s ease;\n\n        svg {\n            font-size: 32px;\n            color: var(--accent-color);\n        }\n\n        &:hover {\n            background: var(--accent-color);\n            transform: scale(1.05);\n\n            svg {\n                color: #fff;\n            }\n        }\n    }\n\n    &__connector {\n        position: absolute;\n        top: 50%;\n        left: calc(50% + 40px);\n        width: calc(100% - 45px);\n        height: 0;\n        border-top: 2px dashed rgba(0, 0, 0, 0.2);\n        transform: translateY(-50%);\n        z-index: 1;\n    }\n\n    &__title {\n        font-size: 20px;\n        font-weight: 700;\n        color: var(--accent-color);\n        margin: 0 0 8px;\n    }\n\n    &__description {\n        font-size: 14px;\n        color: #666;\n        line-height: 1.5;\n        margin: 0;\n        max-width: 180px;\n    }\n\n    &__features {\n        padding: 60px 0 100px;\n    }\n\n    &__features-title {\n        font-size: 32px;\n        font-weight: 700;\n        color: var(--accent-color);\n        text-align: center;\n        margin: 40px 0 40px !important;\n    }\n\n    &__features-grid {\n        display: flex;\n        gap: 16px;\n        max-width: 1200px;\n        margin: 0 auto;\n    }\n\n    &__feature-card {\n        flex: 1;\n        height: 200px;\n        border-radius: 12px;\n        background-size: cover;\n        background-position: center;\n        position: relative;\n        overflow: hidden;\n        cursor: pointer;\n        transition: transform 0.3s ease, box-shadow 0.3s ease;\n\n        &:hover {\n            transform: translateY(-5px);\n            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n\n            .home-process-steps__feature-overlay {\n                background: rgba(10, 36, 77, 0.85);\n            }\n\n            .home-process-steps__feature-description {\n                opacity: 1;\n                max-height: 100px;\n                margin-top: 10px;\n            }\n        }\n    }\n\n    &__feature-overlay {\n        position: absolute;\n        inset: 0;\n        background: linear-gradient(to top, rgba(10, 36, 77, 0.7) 0%, rgba(10, 36, 77, 0) 60%);\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n        padding: 20px;\n        transition: background 0.3s ease;\n    }\n\n    &__feature-title {\n        font-size: 18px;\n        font-weight: 700;\n        color: #fff;\n    }\n\n    &__feature-description {\n        font-size: 13px;\n        color: rgba(255, 255, 255, 0.9);\n        line-height: 1.5;\n        margin: 0;\n        opacity: 0;\n        max-height: 0;\n        overflow: hidden;\n        transition: opacity 0.3s ease, max-height 0.3s ease, margin 0.3s ease;\n    }\n\n    @media only screen and (max-width: 768px) {\n        padding: 60px 0 40px;\n\n        &__container {\n            flex-direction: column;\n            align-items: center;\n            gap: 40px;\n        }\n\n        &__item {\n            width: 100%;\n            max-width: 300px;\n        }\n\n        &__connector {\n            display: none;\n        }\n\n        &__description {\n            max-width: 100%;\n        }\n\n        &__features-title {\n            font-size: 24px;\n        }\n\n        &__features-grid {\n            flex-wrap: wrap;\n        }\n\n        &__feature-card {\n            flex: 0 0 calc(50% - 8px);\n            height: 160px;\n        }\n    }\n\n    @media only screen and (max-width: 480px) {\n        &__feature-card {\n            flex: 0 0 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-process-steps": `HomeProcessSteps_home-process-steps__+2W4U`,
	"home-process-steps__container": `HomeProcessSteps_home-process-steps__container__uDMlJ`,
	"home-process-steps__item": `HomeProcessSteps_home-process-steps__item__sQl0g`,
	"home-process-steps__icon-wrapper": `HomeProcessSteps_home-process-steps__icon-wrapper__DFDcr`,
	"home-process-steps__icon": `HomeProcessSteps_home-process-steps__icon__XWOCa`,
	"home-process-steps__connector": `HomeProcessSteps_home-process-steps__connector__13SFC`,
	"home-process-steps__title": `HomeProcessSteps_home-process-steps__title__hQEzt`,
	"home-process-steps__description": `HomeProcessSteps_home-process-steps__description__2EQ1j`,
	"home-process-steps__features": `HomeProcessSteps_home-process-steps__features__+V-ZA`,
	"home-process-steps__features-title": `HomeProcessSteps_home-process-steps__features-title__gXNii`,
	"home-process-steps__features-grid": `HomeProcessSteps_home-process-steps__features-grid__c5Rw8`,
	"home-process-steps__feature-card": `HomeProcessSteps_home-process-steps__feature-card__QWazK`,
	"home-process-steps__feature-overlay": `HomeProcessSteps_home-process-steps__feature-overlay__9Ufzr`,
	"home-process-steps__feature-description": `HomeProcessSteps_home-process-steps__feature-description__lYycU`,
	"home-process-steps__feature-title": `HomeProcessSteps_home-process-steps__feature-title__YPUNs`
};
export default ___CSS_LOADER_EXPORT___;
